import { createContext } from "react";

const ScalingContext = createContext();

export default ScalingContext;
